<template>
  <v-container>
    <div>
      <p class="display-2 text-center font-weight-bold indigo--text">Meet the Board</p>
    </div>
    <v-row no-gutters>
      <v-col v-for="(person, i) in members" :key="i" class="pa-2" cols="3">
        <MEM  :author="person" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MEM from "../Article/Author.vue";
export default {
  components: {
    MEM
  },
  data: () => ({
    members: [
      { name: "Marguerite Feitlowitz" },
      { name: "Alyssa Pong" },
      { name: "Hafsa Zulfiqar" },
      { name: "John Baller" },
      { name: "Maria Morelos" },
      { name: "Michalina Aniol" },
      { name: "Sarah Lore" },
      { name: "Srichchha Pradhan" },
      { name: "Suzanne Rejali" },
      { name: "Valeria Sibrian Quijada" },
      { name: "Yufei Lin" },
      { name: "Zanna Huth" },
    ]
  })
};
</script>